import Maybe from 'components/elements/maybe';
import NumberText from 'components/elements/numberText';
import { PdpType } from 'lib/apis/services/PdpSingle';
import { useOwnTranslate } from 'lib/hooks/useOwnTranslate';
import { nFormatter } from 'lib/utils/helpers/numberFormat';
import { PropsWithChildren } from 'react';

interface Props extends Pick<PdpType.PdpSingle, 'pricing'> {
  forContactInfo?: boolean;
}

interface PricingContainerType extends PropsWithChildren {
  forContactInfo: boolean;
}

const PricingContainer = ({
  children,
  forContactInfo,
}: PricingContainerType) => {
  if (forContactInfo) {
    return (
      <p className='w-full text-lg font-bold text-primary-800'>
        <span>{children}</span>
      </p>
    );
  }
  return (
    <h2 className='mb-6 font-semiBold text-primary-800 text-display-sm'>
      {children}
    </h2>
  );
};

function PropertyPricing({ pricing, forContactInfo = false }: Props) {
  const { t } = useOwnTranslate('plp.card');
  const isBuy = pricing.listingType === 'BUY';
  return (
    <>
      {/* buy */}
      <Maybe condition={isBuy}>
        <PricingContainer forContactInfo={forContactInfo}>
          <span>{t('pdp.totalPrice', true)}: </span>
          {!pricing.agreedPrice ? (
            <NumberText>
              {pricing.price ? pricing.price.toString() : '0'}
            </NumberText>
          ) : (
            t('adaptive')
          )}
        </PricingContainer>
        <Maybe condition={!pricing.agreedPrice && pricing.unitPrice && pricing.unitPrice !== 0}>
          <p className='text-xl text-gray-500 font-regular'>
            <span>{t('unitPrice')}</span>
            <NumberText>
              {pricing.unitPrice ? pricing.unitPrice.toString() : '0'}
            </NumberText>
          </p>

        </Maybe>
      </Maybe>

      {/* rent */}
      <Maybe condition={!isBuy}>
        {/*توافقی*/}
        <Maybe condition={(!pricing.depositOnly && pricing.agreedPrice)}>
          <PricingContainer forContactInfo={forContactInfo}>
            {t('depositAgreed')}
          </PricingContainer>
          <PricingContainer forContactInfo={forContactInfo}>
            {t('rentAgreed')}
          </PricingContainer>
        </Maybe>
        {/*رهن کامل*/}
        <Maybe condition={pricing.depositOnly && !pricing.agreedPrice}>
          {/* fix */}
          <PricingContainer forContactInfo={forContactInfo}>
            {t('deposit', false, {
              currency: 'تومان',
              price: nFormatter(pricing.deposit || 0),
            })}
          </PricingContainer>
          <PricingContainer forContactInfo={forContactInfo}>
            {t('isDepositOnly')}
          </PricingContainer>
        </Maybe>
        {/*رهن کامل و توافقی با هم */}
        <Maybe condition={pricing.depositOnly && pricing.agreedPrice}>
          <PricingContainer forContactInfo={forContactInfo}>
            {t('depositAgreed')}
          </PricingContainer>
          <PricingContainer forContactInfo={forContactInfo}>
            {t('isDepositOnly')}
          </PricingContainer>
        </Maybe>
        {/*رهن یا اجاره باشه*/}
        <Maybe condition={!pricing.depositOnly && !pricing.agreedPrice}>
          {/*مبلغ رهن همیشه وجود خواهد داشت و این قسمت نمایش داده می شود در صورت صفر بودن مبلغ رهن رایگان نوشته شود*/}
          <PricingContainer forContactInfo={forContactInfo}>
            {pricing.deposit == 0 && t('deposit', false, { currency: "", price: "رایگان" })}
            {pricing.deposit !== 0 && t('deposit', false, {
              currency: 'تومان',
              price: nFormatter(pricing.deposit || 0),
            })}
          </PricingContainer>
          {/*اگر مبلغ اجاره وجود نداشته باشد این قسمت نمایش داده می شود*/}
          {pricing.rent && (
            <PricingContainer forContactInfo={forContactInfo}>
              {t('rent', false, {
                currency: 'تومان',
                price: nFormatter(pricing.rent || 0),
              })}
            </PricingContainer>
          )}
        </Maybe>
      </Maybe>
    </>
  );
}

export default PropertyPricing;
